// Layered drifting radial-gradient blobs — the aurora borealis behind the panel
// header and the launcher glow. Additive (mix-blend-screen) over a dark ground.
export function Aurora({ className = '' }: { className?: string }) {
  return (
    <div
      className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`}
      aria-hidden="true"
    >
      <div className="absolute left-[-8%] top-[-34%] size-64 animate-aurora-a rounded-full bg-[radial-gradient(closest-side,#1790ff,transparent_72%)] mix-blend-screen blur-2xl motion-reduce:animate-none" />
      <div className="absolute left-[36%] top-[-45%] size-60 animate-aurora-b rounded-full bg-[radial-gradient(closest-side,#10fab8,transparent_72%)] mix-blend-screen blur-2xl motion-reduce:animate-none" />
      <div className="absolute left-[60%] top-[-30%] size-56 animate-aurora-c rounded-full bg-[radial-gradient(closest-side,#a2eeff,transparent_72%)] mix-blend-screen blur-2xl motion-reduce:animate-none" />
      <div className="absolute left-[14%] top-[-12%] size-52 animate-aurora-a rounded-full bg-[radial-gradient(closest-side,#7a67f0,transparent_74%)] mix-blend-screen blur-2xl motion-reduce:animate-none" />
    </div>
  )
}
